import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343330f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3" }
const _hoisted_5 = { class: "login-card" }
const _hoisted_6 = { class: "login-body" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-md-12 col-8",
    "data-v-fae5bece": ""
  }, [
    /*#__PURE__*/_createElementVNode("p", {
      "data-v-fae5bece": "",
      style: {"font-size":"1.7rem","font-weight":"700","letter-spacing":"0.1rem"}
    }, " Reset Password, ")
  ])
], -1))
const _hoisted_8 = { class: "form-group mt-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "new_password",
  class: "font-grey"
}, "New Password", -1))
const _hoisted_10 = { class: "form-group mt-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "confirm_password",
  class: "font-grey"
}, "Confirm Password", -1))
const _hoisted_12 = { class: "col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3" }
const _hoisted_13 = { class: "row justify-content-center mx-md-0 mx-1 mb-5" }
const _hoisted_14 = { class: "col-md-12 col-12 px-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "subBtn",
  type: "submit",
  class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
}, " Change Password ", -1))
const _hoisted_16 = { class: "text-muted text-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          method: "POST",
          action: "/",
          class: "my-1",
          onSubmit: _ctx.submitPassword
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_Field, {
                        rules: _ctx.requiredField,
                        id: "new_password",
                        onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                        autocomplete: "off",
                        type: "password",
                        placeholder: "New password here ...",
                        class: "form-control selected-field",
                        name: "new_password",
                        modelValue: _ctx.form.new_password,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.new_password) = $event)),
                        required: ""
                      }, null, 8, ["rules", "modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        style: {"color":"#d00000"},
                        name: "new_password"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_Field, {
                        rules: _ctx.requiredField,
                        id: "confirm_password",
                        onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                        autocomplete: "off",
                        type: "password",
                        placeholder: "Confirm password here..",
                        class: "form-control selected-field",
                        name: "confirm_password",
                        modelValue: _ctx.form.confirm_password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.confirm_password) = $event)),
                        required: ""
                      }, null, 8, ["rules", "modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        style: {"color":"#d00000"},
                        name: "confirm_password"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        class: "success",
                        to: "/",
                        style: {"font-size":"0.9rem","color":"#333"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Have you remember the password ? ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ], 64))
}